import api from './api';
import ErrorHandler from './errorHandler';

class PrintTemplateFeedbackService {
    /**
     * Submit feedback. Always multipart — the image is optional, but sending one
     * shape keeps the endpoint from having to guess.
     */
    async submit({ message, image }) {
        try {
            const form = new FormData();
            form.append('message', message);
            if (image) form.append('image', image, image.name || 'feedback.png');
            return await api.post('/api/print-template-feedback', form);
        } catch (error) {
            throw ErrorHandler.handleError(error);
        }
    }

    /** Admin list — { status, sort, page, limit }. */
    async list(params = {}) {
        try {
            return await api.get('/api/print-template-feedback', { params });
        } catch (error) {
            throw ErrorHandler.handleError(error);
        }
    }

    /** Admin: 'pending' | 'solved' | 'rejected'. */
    async setStatus(id, status, note) {
        try {
            return await api.patch(`/api/print-template-feedback/${id}/status`, { status, note });
        } catch (error) {
            throw ErrorHandler.handleError(error);
        }
    }

    async remove(id) {
        try {
            return await api.delete(`/api/print-template-feedback/${id}`);
        } catch (error) {
            throw ErrorHandler.handleError(error);
        }
    }
}

export default new PrintTemplateFeedbackService();
